import request from './request'

export const getRet00cdTree = () =>
  request<{ data: { items: any[] } }>('/console/ret00cds', {
    method: 'GET',
  })

export const createRet00cd = (data: any) =>
  request('/console/ret00cds', {
    method: 'POST',
    data,
  })

export const updateRet00cd = (id: string | number, data: any) =>
  request(`/console/ret00cds/${id}`, {
    method: 'PUT',
    data,
  })

export const destroyRet00cd = (id: string | number) =>
  request(`/console/ret00cds/${id}`, {
    method: 'DELETE',
  })
